<template>
    <div>
        <label :class="style.fileInput">
            <input type="file" :multiple="multiple" @change="processFile" accept=".7z,.ace,.doc,.docx,.gif,.jpg,.jpeg,.ods,.odt,.pdf,.png,.rar,.rtf,.tif,.txt,.xls,.xlsx,.xps,.zip">
        </label>
        <modal-workboard :max-width="520" v-show="showError" @close="showError = false">
            <h4>Ошибка</h4>
            <p>Следующие файлы имеют неподдерживаемый формат:</p>
            <ul>
                <li v-for="(item, index) in invalidFileNames" :key="index">{{ item }}</li>
            </ul>
            <p>Поддерживаются следующие форматы файлов: 7z, ace, doc, docx, gif, jpg, jpeg, ods, odt, pdf, png, rar, rtf, tif, txt, xls, xlsx, xps, zip.</p>
            <button-red @click="showError = false">ОК</button-red>
        </modal-workboard>
    </div>
</template>

<script>
    import Vue from 'vue'
    import style from './style.module.scss'

    import modalWorkboard from '@/components/common/modal/modal-workboard.vue'
    import buttonRed from '@/components/common/click/button/button-red.vue'

    import { validateFilesExt } from '@/utils/validation'

    export default Vue.extend({
        name: 'file-input',
        components: {
            modalWorkboard,
            buttonRed
        },
        props: {
            multiple: Boolean
        },
        data() {
            return {
                style: style,
                files: [],
                showError: false,
                invalidFileNames: [],
                extensions: [ '7z', 'ace', 'doc', 'docx', 'gif', 'jpg', 'jpeg', 'ods', 'odt', 'pdf', 'png', 'rar', 'rtf', 'tif', 'txt', 'xls', 'xlsx', 'xps', 'zip' ]
            }
        },
        methods: {
            processFile(event) {
                const files = Array.from(event.target.files);

                const validatedFiles = this.validateFilesExt(files, this.extensions);
                
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                const component = this;
                const readers = [];
                validatedFiles.valid.forEach((file, i) => {
                    readers[i] = new FileReader();
                    
                    readers[i].addEventListener("load", (event) => {
                        component.files.push({
                            Name: file.name,
                            Content: event.target.result.split(',')[1]
                        });

                        component.$emit('load', component.files);
                    }, false);

                    if (file) {
                        readers[i].readAsDataURL(file);
                    }
                })

                if (validatedFiles.invalid.length > 0) {
                    this.invalidFileNames = validatedFiles.invalid.map((item) => item.name);
                    this.showError = true;
                }
            },
            deleteFile(index) {
                this.files.splice(index, 1);
            },
            validateFilesExt
            // validateFilesExt(files) {
            //     const valid = [];
            //     const invalid = [];

            //     for (let i = 0; i < files.length; i++) {
            //         const ext = files[i].name.match(/\.([^.]+)$/)[1];
            //         if (this.extensions.indexOf(ext) > -1) {
            //             valid.push(files[i]);
            //         }
            //         else {
            //             invalid.push(files[i]);
            //         }
            //     }

            //     return {
            //         valid,
            //         invalid
            //     };
            // }
        }
    })
</script>